export function SelectDocumentText(documentType: string) {
  switch (documentType) {
    case 'image/*':
      return 'Arrastre las imágenes o haga click acá para buscarlas';
    case 'application/vnd.ms-excel':
      return 'Arrastre el archivo excel o haga click acá para buscarlo';
    default:
      return 'Arrastre o haga click acá para buscarlo';
  }
}
